import { PayloadAction } from '@reduxjs/toolkit';
import { StatusLoading } from 'common/constants/statusLoading';

import { IState } from '../types/state';

const action = (state: IState, payloadAction: PayloadAction<StatusLoading>) => {
  state.savingFilter.statusLoading = payloadAction.payload;
};

export default action;
